import './_v3d.scss';
import {useEffect, useRef} from "react";
import puzzles from "../../utils/puzzles";
const V3D = () => {
    const iframeRef = useRef(null);

    useEffect(() => {
        window.addEventListener('message', function (e) {
            if (e.data === 'v3d_loaded') {
                //@ts-ignore
                puzzles.setProcedures(iframeRef.current.contentWindow.v3d.puzzles.procedures);
            }
        })
    }, []);

    return (
        <div className="v3d-wrapper">
            <iframe id='v3d' src="./envision" title='3D Model' ref={iframeRef}></iframe>
        </div>
    );
}

export default V3D;
